const initialState = {
    totalCountData:[],
    isCountLoading:true,
    userTypeSelect:{label:'All',value:null},
    selectedTab:'1'
}

const cmOverviewTabReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case 'cmOverViewTotalCountData':
    state = {...state, isCountLoading:false};
    return { ...state, totalCountData:payload };
  case 'cmOverViewSelectUser':
    state = {...state, userTypeSelect:payload}; 
    return state;
  case 'cmOverViewSelectTab':
    state = {...state, selectedTab:payload}; 
    return state;
  default:
    return state;
  }
}

export default cmOverviewTabReducer;
